import * as React from 'react';
import { formatMoney } from '../../utils/string';
import * as styles from './BalanceDesktop.css';
import { IBalanceDesktopProps } from './types';

export const BalanceDesktop = (props: IBalanceDesktopProps) => {
  const { balance } = props;

  return (
    <div className={styles['balance_wrapper']}>
      <div>Баланс: {formatMoney(balance)}</div>
    </div>
  );
};
